import type { Resource } from '../../';
export const product_group_men: Resource = {"default":"Men's"};
